import { Pipe, PipeTransform } from '@angular/core';
import { Filter, PoliticalWindowConfigTiersFilter } from '@models/filter-types';
import { isPoliticalWindowConfigTiersFilter } from '@shared/helpers/functions/helpers';

@Pipe({
    name: 'isPoliticalWindowsConfigTierFilter',
    standalone: false,
})
export class IsPoliticalWindowsConfigTierFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is PoliticalWindowConfigTiersFilter<unknown> {
        return isPoliticalWindowConfigTiersFilter(value);
    }
}
